import React, { useMemo } from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import MUITypography from '../../../Components/MUITypography';
import StyledInputField from '../../../Components/Custom/StyledInputField';
import StorageFactory from '../../../Util/StorageFactory';
import { SESSION_USER_COUNTRY_DATA_KEY } from '../../../Util/VMConstants';
import { formatAmount } from '../../../Util/UtilHelper';
import { VM_Colors } from '../../../Styles/VMStyles';

function VenueBilling({ bookedEventState, updateVenueBillingHandler }) {
  const totalCharges = useMemo(
    () =>
      bookedEventState.reduce(
        (sum, item) => sum + (parseFloat(item.event_rent_charges) || 0),
        0
      ),
    [bookedEventState]
  );
  const sessionFactory = new StorageFactory('session');
    const currencySymbol =
      sessionFactory.get(SESSION_USER_COUNTRY_DATA_KEY)?.currency_symbol || '₹';
  

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
      <MUITypography variant="h3" sx={{fontWeight: 700}}>Venue Billing</MUITypography>

      <Paper sx={{ mt: 1, p: 2, borderRadius: 2, width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box' }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="baseline"
          flexWrap="wrap"
          gap={1}
          mb={1}
        >
          <Typography fontWeight={600} sx={{ minWidth: 0 }}>Total Charges</Typography>
          <Typography fontWeight={700} color="success.main" sx={{ flexShrink: 0 }}>
             {formatAmount(totalCharges,currencySymbol)}
          </Typography>
        </Box>

        <Box sx={{ borderTop: '1px dashed #ccc', my: 1 }} />

        {bookedEventState.map((item, index) => (
          <Box key={index} mb={2}>
            <Typography variant="subtitle2" mb={1}>
              Event {index + 1}
            </Typography>

            <Box sx={{ p: 2, borderRadius: 2, backgroundColor: VM_Colors.paper_bg, minWidth: 0 }}>
              <Grid container spacing={2} sx={{ width: '100%', maxWidth: '100%' }}>
                <Grid item xs={12} sm={6} sx={{ minWidth: 0 }}>
                  <StyledInputField
                    label="Event Name"
                    value={item.event_name}
                    onChange={e =>
                      updateVenueBillingHandler(index, 'event_name', e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} sx={{ minWidth: 0 }}>
                  <StyledInputField
                    label="Rent Charges"
                    type="number"
                    value={item.event_rent_charges}
                    onChange={e =>
                      updateVenueBillingHandler(
                        index,
                        'event_rent_charges',
                        e.target.value
                      )
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        ))}
      </Paper>
    </Box>
  );
}

export default VenueBilling;